import type { SupplierStatus } from "../../../../../types/api.types";
import type { VersorgerstatusPeriod } from "../../../../../utils/backend-types";
import { backendDateOrDateTimeToLuxonDateTime } from "../../../../../utils/dates/backendDateOrDateTimeToLuxonDateTime";
import { sortDateTimeOrNull } from "../../../../../utils/dates/sortDateTimeOrNull";
import type { ChangeableFieldData } from "../../../../ChangeableFieldWidget/ChangeableFieldWidget";

/**
 * Converts an array of VersorgerstatusPeriod objects to an array of ChangeableFieldData objects.
 */
export function convertVersorgerstatusPeriodsToChangeableFieldData(
  periods: Array<VersorgerstatusPeriod>
) {
  return periods
    .map<ChangeableFieldData<SupplierStatus>>((period) => ({
      startDate: period.firstDate
        ? backendDateOrDateTimeToLuxonDateTime(period.firstDate)
        : null,
      endDate: period.lastDate
        ? backendDateOrDateTimeToLuxonDateTime(period.lastDate)
        : null,
      value: period.status
    }))
    .sort((a, b) => sortDateTimeOrNull(a.startDate, b.startDate));
}
